import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * ComputeOrdersNumberAfterRecurrenceUpsert
 *
 * @private
 */
export const computeOrdersNumberAfterRecurrenceUpsert = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.actions.rpc.order.ComputeOrdersNumberAfterRecurrenceUpsertResult['result'],
  // First argument to the payload creator
  uui.domain.actions.rpc.order.ComputeOrdersNumberAfterRecurrenceUpsertAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/order/computeOrdersNumberAfterRecurrenceUpsert', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/order/computeOrdersNumberAfterRecurrenceUpsert', {
      category: 'rpc',
      type: 'rpc/order/computeOrdersNumberAfterRecurrenceUpsert',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on computeOrdersNumberAfterRecurrenceUpsert`,
      { tags: ['rpc', 'order'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `computeOrdersNumberAfterRecurrenceUpsert call failed`,
      error,
    })
  }
})
